import { buildSearchableText, matchesAllTerms } from 'core/utils/search';

export const formatDate = (dateString) => {
  if (!dateString) return '-';
  return new Date(dateString).toLocaleDateString('de-DE', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit'
  });
};

export const filterUsers = (users, searchTerm, filterType = 'all') => {
  if (!users) return [];
  
  return users.filter(user => {
    // Search filter — Volltext über alle relevanten Felder; mehrere Begriffe (UND) via Trennzeichen
    const matchesSearch = matchesAllTerms(
      buildSearchableText(
        user.username, user.email, user.company,
        user.firstName, user.lastName, user.role
      ),
      searchTerm
    );

    // Active/Inactive filter (nur für OCI-Benutzer)
    let matchesFilter = true;
    if (user.hasOwnProperty('is_active') && filterType !== 'all') {
      matchesFilter = filterType === 'active' ? user.is_active : !user.is_active;
    }

    return matchesSearch && matchesFilter;
  });
};

export const deleteUser = async (userId, isOci, user, showSuccess, showError, t) => {
  try {
    const endpoint = isOci ? `/api/oci-users/${userId}` : `/api/admin/users/${userId}`;
    const response = await fetch(endpoint, {
      method: 'DELETE',
      headers: {
        'Authorization': `Bearer ${user.token}`
      }
    });

    if (!response.ok) {
      const data = await response.json();
      throw new Error(data.error || t('admin.ociHook.deleteError'));
    }

    showSuccess(isOci ? t('admin.ociHook.deleted') : t('admin.users.deleted'));
    return true;
  } catch (error) {
    showError(error.message);
    return false;
  }
};